import { z } from 'zod'
export const orgDiarySearchSchema = z.object({
  tab: z.coerce
    .number()
    .pipe(z.union([z.literal(0), z.literal(1)]))
    .catch(0),
  internId: z.string().catch(''),
  internshipId: z.string().catch(''),
  page: z.coerce.number().int().positive().catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(25),
  sortBy: z
    .enum(['date', 'intern', 'programitem', 'org', 'time', 'academichours', 'grade'])
    .catch('date'),
  direction: z.enum(['asc', 'desc']).catch('desc'),
})
export type OrgDiarySearch = z.infer<typeof orgDiarySearchSchema>
export const defaultOrgDiarySearch = orgDiarySearchSchema.parse({})
export const orgDiaryRequest = (search: OrgDiarySearch) => ({
  ...search,
  internId: search.internId || undefined,
  internshipId: search.internshipId || undefined,
  sortBy: `${search.sortBy}${search.direction === 'desc' ? '-' : ''}`,
})
export const gradeValues = (type: string | null | undefined): number[] => {
  if (type === 'INI') {
    return [11, 12]
  }
  if (type === 'v5') {
    return [1, 2, 3, 4, 5]
  }
  if (type === 'v10') {
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  }
  if (type === 'INI10') {
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  }
  return []
}
